import classNames from 'clsx';
import React from 'react';
const FormControl = ({ children, className, style, ...rest }) => (React.createElement("div", { className: classNames(className, 'form-control'), style: style, ...rest }, children));
export default FormControl;
